import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
	title: {
		width: "270px",
		height: " 19px",
		margin: "20px 100px 16px 20px",
		fontSize: "16px",
		fontWeight: " 500",
		fontStretch: " normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.36px",
		color: " rgba(71, 71, 71, 0.82)",
	},

	containerLink: {
		height: "144px",
		margin: " 16px 0 0",
		padding: " 30px 62px 16px 27px",
		border: "solid 1px #eaeaea",
		backgroundColor: " #64b3f4",
	},

	linkAppUp: {
		height: " 40px",
		margin: " 0 0 21px 4px",
	},

	titleLinkUp: {
		width: "300px",
		color: "#f2f2f2",
		fontSize: "18px",
	},

	linkplayStore: {
		width: "135px",
		height: "40px",
		margin: "8px 11px 0 0",
		backgroundColor: "#ffffff",
		display: "inline",
		float: "left",
		borderRadius: "4px",
		textDecoration: "none",
	},

	linkAppStore: {
		width: "135px",
		height: "40px",
		margin: "8px 39px 0 11px",
		backgroundColor: "#ffffff",
		float: "left",
		borderRadius: "4px",
		textDecoration: "none",
		position: "absolute",
	},

	linkIcon: {
		color: " #64b3f4",
		padding: "1px",
		margin: "7px  7px 0 15px",
		float: "left",
	},

	nameAppLink: {
		fontSize: "11px",
		textDecoration: "none",
		margin: "4px",
		color: " #64b3f4",
	},

	scrollCredits: {
		display: "flex",
		overflowX: "auto",
		"&::-webkit-scrollbar": {
			width: 0,
		},
		margin: "20px 0px 20px 30px",
	},

	pritCredits: {
		minWidth: "170px",
		maxWidth: "49.3%",
		height: " 48px",
		fontSize: "14px",
		fontWeight: "500",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.31px",
		color: "rgba(71, 71, 71, 0.82)",
	},

	pritCreditsValue: {
		minWidth: "180px",
		height: "64px",
		// margin: "28px 5px 43px 33px",
		// padding: "10px 0 11px 11px",
		borderRadius: "5px",
		boxShadow: "1px 1px 2px 1px rgba(0, 0, 0, 0.03)",
		backgroundColor: " #fafafa",
	},

	ticketIcon: {
		float: "left",
		background: "#ffffff",
		borderRadius: "2em",
	},

	valueCredits: {
		width: "auto",
		height: "13px",
		margin: " 8px 0 3px 11px",
		fontFamily: "CircularStd",
		fontSize: " 10px",
		fontWeight: 500,
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.22px",
	},

	validDate: {
		width: "auto",
		height: "13px",
		margin: "3px 0 6px 8px",
		fontFamily: "CircularStd",
		fontSize: " 10px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: " -0.22px",
	},

	timeStart: {
		width: "31px",
		height: "8px",
		margin: "0 7px 11px 27px",
		color: " rgba(71, 71, 71, 0.5)",
	},

	nameControl1: {
		fontWeight: " 500",
		color: " rgba(71, 71, 71, 0.82)",
		textAlign: "right",
		margin: "0px 35px 0 0",
	},

	nameControl2: {
		width: "auto",
		height: "32px",
		margin: "0 34px 0 76px",
		fontSize: "14px",
		fontWeight: "bold",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.31px",
		textAlign: "right",
		color: "#c2e59c",
	},

	inforUser: {
		color: "#686d71",
		fontSize: "11px",
		height: "19px",
		textAlign: "right",
		margin: "0px 35px 0 0",
	},

	rectangleServices: {
		width: "auto",
		height: "auto",
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		margin: "0 34px 35px 45px",
		padding: " 9px 20px 8px 16px",
		borderRadius: " 5px",
		border: "solid 1px #eaeaea",
		backgroundColor: " #fafafa",
	},

	imageService: {
		float: "left",
		width: " 30px",
		height: " 30px",
		margin: "8px 8px 10px 0",
		borderRadius: " 5px",
		border: "solid 1px var(--white)",
	},

	containerTimesService: {
		margin: " 0 0 5px 8px",
	},

	times: {
		width: "70px",
		height: "10px",
		margin: " 8px 0 10px",
		fontSize: "12px",
		fontWeight: "normal",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.18px",
		color: "#888888",
	},

	nameServices: {
		width: " 115px",
		height: "16px",
		fontFamily: "CircularStd",
		fontSize: "12px",
		fontWeight: "500",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "1.33",
		letterSpacing: "-0.27px",
		color: " #474747",
		float: "left",
	},

	buttons: {
		textAlign: "center",
		width: "71px",
		padding: "inherit",
		float: "right",
		// cursor: "pointer",
	},

	reschedule: {
		width: "71px",
		height: "20px",
		fontSize: "10px",
		borderRadius: "5px",
		border: " solid 1px #eaeaea",
		color: "#adadada8",
		padding: "2px",
		backgroundColor: " #ffffff",
		float: "left",
	},

	cancel: {
		width: "71px",
		height: "20px",
		fontSize: "10px",
		borderRadius: "5px",
		border: " solid 1px #eaeaea",
		backgroundColor: " #ffffff",
		color: "#adadada8",
		padding: "2px",
		float: "left",
		marginTop: "8px",
	},

	messageContainer: {
		width: "auto",
		height: " 64px",
		textAlign: "center",
		margin: " 45px 0 38px 33px",
		padding: "16px 52px 16px 46px",
		borderRadius: "5px",
		border: "solid 1px #eaeaea",
		backgroundColor: " #fafafa",
	},

	notificationIcon: {
		width: "2.5em",
		backgroundColor: "#ffffff",
		float: "left",
		marginLeft: "-36px",
		marginTop: "-30px",
		borderRadius: "2em",
	},

	nameMessage: {
		width: "244px",
		height: "32px",
		fontSize: "15px",
		fontWeight: "600",
		fontStretch: "normal",
		fontStyle: "normal",
		lineHeight: "normal",
		letterSpacing: "-0.31px",
		color: "#64b3f4",
	},

	footer: {
		display: "inline-block",
		padding: " 0px 0 25px 60px",
	},

	// Novos estilos extraídos do componente
	mainContainer: {
		maxHeight: "100vh",
		minHeight: "90vh",
		background: "transparent",
	},

	successHeader: {
		paddingTop: "20px",
		textAlign: "center",
	},

	successIconContainer: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		width: "64px",
		height: "64px",
		backgroundColor: "#234038",
		borderRadius: "50%",
		marginBottom: "16px",
		margin: "0 auto 16px auto",
	},

	successIcon: {
		color: "#fff",
		fontSize: "45px",
	},

	successTitle: {
		fontSize: "clamp(28px, 1vw, 32px)",
		color: "#222",
		fontWeight: "bold",
		textAlign: "center",
	},

	buttonWrapper: {
		display: "flex",
		flexDirection: "column",
		marginTop: 25,
		alignItems: "center",
		paddingBottom: 80
	},

	buttonText: {
		fontSize: "14px",
		color: "#666666",
		lineHeight: "1.4",
		textAlign: "center",
		width: "100%"
	},

	containerPritText: {
		width: '92%',
		display: 'flex', 
		flexDirection: 'column', 
		justifyContent: 'center', 
		alignItems: 'center',
		backgroundColor: '#FCF6F6',
		padding: "8px 16px",
		borderRadius: '20px',
		border: '1px solid #22222218'
	},

	pritTitle: {
		fontSize: "16px",
		fontWeight: "600",
		color: "#4C4042",
		lineHeight: "1.3",
	},

	pritSubtitle: {
		fontSize: "14px",
		color: "#464040",
		lineHeight: "1.4",
		marginTop: "4px",
		textAlign: "center",
	},

	primaryButton: {
		color: "white",
		width: "100%",
		background: "#672E37",
		borderRadius: "100px",
		textTransform: "none",
		fontWeight: "bold",
		padding: "8px 20px",
		"&:hover": {
			backgroundColor: "#5a2830"
		},
	},

	businessName: {
		fontSize: 24,
		fontWeight: 600,
		color: "#333333",
	},

	businessInfo: {
		fontSize: 16,
		color: "#666666",
		textAlign: "center",
	},

	businessInfoContainer: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		marginBottom: 15,
	},

	businessInfoContainerLeft: {
		display: "flex",
		justifyContent: "flex-start",
		alignItems: "center",
		marginBottom: 15,
	},

	businessInfoLeft: {
		fontSize: "clamp(14px, 1vw, 16px)",
		color: "#fff",
		textAlign: "left",
	},

	mapButton: {
		color: "#672E37",
		backgroundColor: "transparent",
		border: "1px solid #672E37",
		borderRadius: "20px",
		textTransform: "none",
		fontSize: "14px",
		fontWeight: "500",
		marginLeft: "16px",
		minWidth: "140px",
		"&:hover": {
			backgroundColor: "#672E37",
			color: "white",
		},
	},

	divider: {
		margin: "16px 0",
	},



	paymentSummary: {
		marginBottom: "16px",
	},

	paymentTitle: {
		fontSize: "18px",
		fontWeight: "bold",
		color: "#333333",
		marginBottom: "12px",
	},

	businessInfoTitle: {
		fontSize: "18px",
		fontWeight: "bold",
		color: "#333333",
		marginBottom: "12px",
	},



	cancellationPolicy: {
		fontSize: "16px",
		fontWeight: "bold",
		color: "#333333",
		marginBottom: "2px",
	},

	cancellationText: {
		fontSize: "14px",
		color: "#666666",
		lineHeight: "1.4",
	},

	titleContainerChildren: {
		padding: 0,
	},

	referralButton: {
		backgroundColor: "transparent",
		color: "#672E37",
		border: "1px solid #672E37",
		width: "100%",
		borderRadius: "100px",
		textTransform: "none",
		fontWeight: "600",
		fontSize: "clamp(12px, 2vw, 14px)",
		"&:hover": {
			backgroundColor: "#f5f5f5",
			color: "#672E37",
		},
	},

	referralButtonText: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		lineHeight: "1.3",
	},

	// Header (avatar + texts) shown over the background image
	headerBusinessBar: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		margin: "20px 20px",
	},

	headerAvatar: {
		width: 56,
		height: 56,
		backgroundColor: "#8C1837",
	},

	headerTexts: {
		display: "flex",
		flexDirection: "column",
		marginLeft: 16,
		minHeight: 100,
	},

	headerName: {
		fontSize: "clamp(24px, 2vw, 26px)",
		fontWeight: 600,
		color: "#222",
		lineHeight: 1.2,
		marginTop: 4,
	},

	headerInfo: {
		fontSize: "14px",
		color: "#222",
		lineHeight: 1.2,
		marginTop: 2,
	},

	headerInfoUnderlined: {
		fontSize: "12px",
		color: "#222",
		lineHeight: 1.3,
		marginTop: 2,
		textDecoration: "underline",
		cursor: "pointer",
		marginBottom: 2,
	},

	headerInfoClickable: {
		fontSize: "14px",
		color: "rgba(255,255,255,0.85)",
		lineHeight: 1.2,
		marginTop: 2,
		cursor: "pointer",
	},

	// Cards for address and phone (light containers)
	infoCard: {
		backgroundColor: "#ffffff",
		border: "solid 1px #eaeaea",
		borderRadius: 12,
		padding: 16,
		margin: "8px 20px",
		boxShadow: "1px 1px 2px 1px rgba(0, 0, 0, 0.03)",
	},

	infoCardHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: 8,
	},

	infoCardLeft: {
		display: "flex",
		alignItems: "center",
		gap: 12,
		flex: 1,
		minWidth: 0,
	},

	infoIconContainer: {
		width: 36,
		height: 36,
		borderRadius: 18,
		backgroundColor: "#f5f5f5",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		color: "#333333",
	},

	infoTextDark: {
		fontSize: 18,
		color: "#333333",
		lineHeight: 1.3,
		whiteSpace: "nowrap",
		overflow: "hidden",
		textOverflow: "ellipsis",
	},

	pillRow: {
		marginTop: 12,
		display: "flex",
		alignItems: "center",
		gap: 8,
	},

	pillButton: {
		backgroundColor: "#f2f2f2",
		color: "#333333",
		borderRadius: 12,
		textTransform: "none",
		padding: "8px 16px",
		minHeight: 0,
		boxShadow: "none",
		border: "1px solid #eaeaea",
		"&:hover": {
			backgroundColor: "#ebebeb",
		},
	},

	whatsAppPill: {
		backgroundColor: "#4dc247",
		color: "#ffffff",
		borderRadius: 12,
		textTransform: "none",
		padding: "8px 16px",
		minHeight: 0,
		"&:hover": {
			backgroundColor: "#43ad40",
		},
	},

	// Animações de entrada
	"@keyframes fadeOutTop": {
		from: {
			opacity: 1,
		},
		to: {
			opacity: 0,
		},
	},

	"@keyframes fadeOutBackground": {
		from: {
			opacity: 1,
		},
		to: {
			opacity: 0.8,
		},
	},

	"@keyframes slideUpSpring": {
		from: {
			opacity: 0,
			transform: "translateY(80px)",
		},
		to: {
			opacity: 1,
			transform: "translateY(0)",
		},
	},

	"@keyframes fadeInContent": {
		from: {
			opacity: 0,
		},
		to: {
			opacity: 1,
		},
	},

	// Classes de animação
	animatedTopFadeOut: {
		animation: "$fadeOutTop 0.15s ease-out forwards",
	},

	animatedBackgroundFadeOut: {
		animation: "$fadeOutBackground 0.10s ease-out forwards",
	},

	animatedSlideUp: {
		animation: "$slideUpSpring 0.25s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards",
		// cubic-bezier simula spring damping 0.85 sem bounce (ease-out quad)
	},

	animatedContentFadeIn: {
		animation: "$fadeInContent 0.15s ease-out 0.25s forwards",
		// Delay de 0.25s para começar simultaneamente quando o slide up termina
	},
}));
